import { SET_SWITCHER } from './actionTypes';

const initialState = {
  isSwitcherOpen: localStorage.getItem('isDarkTheme') === 'true',
};

export default function switcher(state = initialState, action) {
  switch (action.type) {
    case SET_SWITCHER:
      localStorage.setItem('isDarkTheme', action.payload.toggle);
      //add cookie with theme for keycloak
      const hostname = window.location.hostname.split('.');
      const subdomain = hostname[1] + '.' + hostname[2];
      document.cookie = 'isDarkTheme='+action.payload.toggle+';path=/;domain=' + subdomain;
      return {
        ...state,
        isSwitcherOpen: action.payload.toggle,
      };
    default:
      return state;
  }
}

export function getIsDarkMode(state) {
  return !!state.switcher.isSwitcherOpen;
}
